import { z } from "zod";

export type GeneralIdResponse = z.infer<typeof GeneralIdResponseSchema>;
export const GeneralIdResponseSchema = z.object({
  activation_flg: z.boolean(),
  id: z.string(),
});
